import getColor from "@insite/mobius/utilities/getColor";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { iconScalableStyles } from "@store/Themes/common/mixins/icon";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { css } from "styled-components";

export const linkStyles = (color: string, hoverColor: string | null, underline: boolean, hoverUnderline: boolean) => {
    const _hoverColor = hoverColor || color;

    return css`
        ${focusStyles()}
        transition: ${transitionHoverStyles("color")};
        color: ${getColor(color)};
        text-decoration: ${underline ? "underline" : "none"};
        vertical-align: top;

        &:hover,
        &:active {
            color: ${getColor(_hoverColor)};
            text-decoration: ${hoverUnderline ? "underline" : "none"};
        }

        &:disabled {
            color: ${getColor("text.disabled")};
            text-decoration: ${underline ? "underline" : "none"};
            cursor: default;
        }
    `;
};

export const linkAltStyles = () => linkStyles("text.linkAlt", "text.linkAltHover", false, true);

export const linkActionStyles = (fontSize?: string) => css`
    ${({ theme }) => css`
        ${theme.link.defaultProps?.css}
        font-size: ${fontSize || theme.design.typography.size.smaller};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const linkIconStyles = (size = "1.3em", spacing = "0.3em") => css`
    ${iconScalableStyles(size)}
    margin-right: ${spacing};
    margin-left: ${spacing};

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }
`;
